import { bindActionCreators, compose } from "redux";
import { Form } from 'antd';
import { connect } from "react-redux";

import { updateCampaign } from "../../../../campaign/campaignActions";

import CampaignsSettingsTransactionsGoalForm from './CampaignsSettingsTransactionsGoalForm';

const mapStateToProps = state => ({
  campaign: state.campaign.campaign,
  locale: state.session.language,
  campaignSettings: state.campaign.campaign.settings,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  updateCampaign
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  Form.create()
)(CampaignsSettingsTransactionsGoalForm);
